import { defineComponent as p, computed as t, openBlock as C, createBlock as u, resolveDynamicComponent as y, normalizeClass as a, withCtx as f, createElementVNode as r, renderSlot as d } from "vue";
import '../assets/BaseCard.css';const k = /* @__PURE__ */ p({
  __name: "BaseCard",
  props: {
    type: { default: "" },
    rootComponent: { default: "div" },
    cardImgClasses: { default: "" },
    cardBodyClasses: { default: "" }
  },
  emits: ["click"],
  setup(l, { emit: c }) {
    const n = c, s = l, m = t(
      () => s.type === "news" ? "news-card" : s.type
    ), i = t(() => s.type ? `${s.type}-img` : "");
    return (e, o) => (C(), u(y(e.rootComponent), {
      class: a(["card", [m.value]]),
      onClick: o[0] || (o[0] = (v) => n("click"))
    }, {
      default: f(() => [
        r("div", {
          class: a(["card-img", [i.value, e.cardImgClasses]])
        }, [
          d(e.$slots, "card-image")
        ], 2),
        r("div", {
          class: a(["card-body", [e.cardBodyClasses]])
        }, [
          d(e.$slots, "card-description")
        ], 2)
      ]),
      _: 3
    }, 8, ["class"]));
  }
});
export {
  k as _
};
